/**
 * Company Subscription Service - Company-level trial and subscription APIs
 */
import axios from 'axios';
import API_CONFIG from '../config/api.config';
import { getAuthHeader } from './authService';

const API_BASE = API_CONFIG.BASE_URL;

export const createTrial = async ({ planId, planCode, planName }) => {
  const response = await axios.post(
    `${API_BASE}/company-subscriptions/trial`,
    { planId, planCode, planName },
    { headers: getAuthHeader() }
  );
  return response.data;
};

export const getTrialStatus = async () => {
  const response = await axios.get(
    `${API_BASE}/company-subscriptions/trial-status`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

export const getSubscriptionStatus = async () => {
  const response = await axios.get(
    `${API_BASE}/company-subscriptions/subscription-status`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

/**
 * Get active add-on definitions (catalog) for the current company to choose from
 */
export const getActiveAddonDefinitions = async () => {
  const response = await axios.get(
    `${API_BASE}/company-subscriptions/addon-definitions/active`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

/**
 * Get add-ons purchased by the current company
 */
export const getMyAddons = async () => {
  const response = await axios.get(
    `${API_BASE}/company-subscriptions/my-addons`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

/**
 * Preview add-on price for current company (quantity, duration type)
 */
export const previewMyAddonPrice = async (addonDefinitionId, quantityUnits = 1, durationType = 'REMAINING') => {
  const response = await axios.post(
    `${API_BASE}/company-subscriptions/my-addons/preview`,
    { addonDefinitionId, quantityUnits, durationType },
    { headers: getAuthHeader() }
  );
  return response.data;
};

/**
 * Get add-on bonus counts for current company (effective limit = plan limit + bonus for Users, Locations, Products).
 */
export const getAddonBonuses = async () => {
  const response = await axios.get(
    `${API_BASE}/company-subscriptions/addon-bonuses`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

export default {
  createTrial,
  getTrialStatus,
  getSubscriptionStatus,
  getActiveAddonDefinitions,
  getMyAddons,
  previewMyAddonPrice,
  getAddonBonuses
};

